<template>
    <Form
        :sms-clients-settings="smsClientsSettings"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script setup>
import Form from '~@/Components/Settings/SmsClientsSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    smsClientsSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const submitData = (form) => {
    form.post(route('settings.sms-clients-settings.store'))
}
</script>
